{
  "app.navigation.account": "Account",
  "app.navigation.billing": "Billing",
  "app.navigation.integrations": "Integrations",
  "app.navigation.occasions": "Occasions",
  "app.navigation.overview": "Overview",
  "app.navigation.settings": "Settings",
  "app.navigation.support": "Support",
  "app.router.app_router_retry_session_load": "Retry Session Load",
  "components.actor_editor_form.not_set": "Not Set",
  "components.app_shell.components_app_shell_tap_share_in_safari": "Tap Share In Safari",
  "components.app_shell.components_app_shell_view_account": "View Account",
  "components.app_shell.sign_out": "Sign Out",
  "components.billing_plan_gate.change_plan": "Change Plan",
  "components.billing_plan_gate.current_plan": "Current Plan",
  "components.billing_plan_gate.plan_required": "Plan Required",
  "components.billing_plan_gate.plan_required_description": "Plan Required Description",
  "components.billing_plan_gate.required_plan": "Required Plan",
  "components.cached_data_notice.reconnect_to_refresh": "Reconnect To Refresh",
  "components.cached_data_notice.showing_saved_data_from": "Showing Saved Data From",
  "components.cached_data_notice.showing_saved_data_some_details_may_be_outdated": "Showing Saved Data Some Details May Be Outdated",
  "components.calendar.more": "More",
  "components.color_picker.mode": "Mode",
  "components.combobox.components_combobox_no_matching_options": "No Matching Options",
  "components.combobox.components_combobox_search_options": "Search Options",
  "components.combobox.components_combobox_select_option": "Select Option",
  "components.data_views.bulk_actions.add_to_group": "Add To Group",
  "components.data_views.bulk_actions.add_to_household": "Add To Household",
  "components.data_views.bulk_actions.change_status": "Change Status",
  "components.data_views.bulk_actions.change_status_to": "Change Status To",
  "components.data_views.bulk_actions.choose_target": "Choose Target",
  "components.data_views.bulk_actions.create_target": "Create Target",
  "components.data_views.bulk_actions.search_groups": "Search Groups",
  "components.data_views.bulk_actions.search_households": "Search Households",
  "components.data_views.bulk_actions.select_row": "Select Row",
  "components.data_views.bulk_actions.select_visible_rows": "Select Visible Rows",
  "components.data_views.bulk_actions.this_action_cannot_be_undone": "This action cannot be undone",
  "components.data_views.collection_calendar_view.components_data_views_add_item": "Components Data Views Add Item",
  "components.data_views.collection_calendar_view.components_data_views_next": "Components Data Views Next",
  "components.data_views.collection_calendar_view.components_data_views_next_year": "Components Data Views Next Year",
  "components.data_views.collection_calendar_view.components_data_views_previous": "Components Data Views Previous",
  "components.data_views.collection_calendar_view.components_data_views_previous_year": "Components Data Views Previous Year",
  "components.data_views.collection_calendar_view.components_data_views_today": "Components Data Views Today",
  "components.data_views.collection_calendar_view.day_view": "Day View",
  "components.data_views.collection_calendar_view.month_view": "Month View",
  "components.data_views.collection_calendar_view.week_view": "Week View",
  "components.data_views.collection_gantt_view.rgb_100_116_139": "Rgb 100 116",
  "components.data_views.collection_gantt_view.rgb_225_29_72": "Rgb 225 29",
  "components.data_views.collection_gantt_view.rgb_59_130_246": "Rgb 59 130",
  "components.data_views.collection_table_view.actions": "Actions",
  "components.data_views.data_view_column_preferences_menu.customize_table": "Customize Table",
  "components.data_views.data_view_column_preferences_menu.delete_preset": "Delete Preset",
  "components.data_views.data_view_column_preferences_menu.display_options": "Display Options",
  "components.data_views.data_view_column_preferences_menu.export": "Export",
  "components.data_views.data_view_column_preferences_menu.group_by": "Group By",
  "components.data_views.data_view_column_preferences_menu.no_grouping": "No Grouping",
  "components.data_views.data_view_column_preferences_menu.reorder_column": "Reorder Column",
  "components.data_views.data_view_column_preferences_menu.save_preset": "Save Preset",
  "components.data_views.data_view_column_preferences_menu.search_presets": "Search Presets",
  "components.data_views.data_view_shell.customize_view": "Customize View",
  "components.data_views.data_view_table.load_more": "Load More",
  "components.data_views.export_dialog.all_items": "All Items",
  "components.data_views.export_dialog.current_filter": "Current Filter",
  "components.data_views.export_dialog.current_page": "Current Page",
  "components.data_views.export_dialog.export": "Export",
  "components.data_views.export_dialog.export_failed": "Export Failed",
  "components.data_views.export_dialog.export_ready": "Export Ready",
  "components.data_views.export_dialog.exporting": "Exporting",
  "components.data_views.export_dialog.fields": "Fields",
  "components.data_views.export_dialog.format": "Format",
  "components.data_views.export_dialog.items": "Items",
  "components.data_views.export_dialog.select_at_least_one_field": "Select At Least One Field",
  "components.data_views.gantt_link_dependency": "Gantt Link Dependency",
  "components.data_views.gantt_reset_zoom": "Gantt Reset Zoom",
  "components.data_views.gantt_scale_daily": "Gantt Scale Daily",
  "components.data_views.gantt_scale_monthly": "Gantt Scale Monthly",
  "components.data_views.gantt_scale_quarterly": "Gantt Scale Quarterly",
  "components.data_views.gantt_timeline_scale": "Gantt Timeline Scale",
  "components.data_views.gantt_timeline_zoom": "Gantt Timeline Zoom",
  "components.data_views.gantt_zoom_in": "Gantt Zoom In",
  "components.data_views.gantt_zoom_out": "Gantt Zoom Out",
  "components.date_time_picker.components_date_time_picker_am": "Am",
  "components.date_time_picker.components_date_time_picker_day": "Day",
  "components.date_time_picker.components_date_time_picker_month": "Month",
  "components.date_time_picker.components_date_time_picker_next_month": "Next Month",
  "components.date_time_picker.components_date_time_picker_period": "Period",
  "components.date_time_picker.components_date_time_picker_pick_a_date": "Pick a Date",
  "components.date_time_picker.components_date_time_picker_pm": "Pm",
  "components.date_time_picker.components_date_time_picker_previous_month": "Previous Month",
  "components.date_time_picker.components_date_time_picker_second": "Second",
  "components.date_time_picker.components_date_time_picker_year": "Year",
  "components.date_time_picker.hours": "Hours",
  "components.date_time_picker.minutes": "Minutes",
  "components.date_time_picker.pp": "Pp",
  "components.date_time_picker.pp_hh_00": "Pp Hh",
  "components.date_time_picker.pp_hh_b": "Pp Hh b",
  "components.date_time_picker.pp_hh_mm": "Pp Hh Mm",
  "components.date_time_picker.pp_hh_mm_b": "Pp Hh Mm b",
  "components.date_time_picker.pp_hh_mm_ss": "Pp Hh Mm Ss",
  "components.date_time_picker.pp_hh_mm_ss_b": "Pp Hh Mm Ss b",
  "components.date_time_picker.seconds": "Seconds",
  "components.delete_confirmation_dialog.are_you_sure": "Are You Sure",
  "components.delete_confirmation_dialog.this_action_cannot_be_undone": "This Action Cannot Be Undone",
  "components.dialog_page.deleting": "Deleting",
  "components.dropzone.accepts": "Accepts",
  "components.dropzone.and": "And",
  "components.dropzone.at_least": "At Least",
  "components.dropzone.between": "Between",
  "components.dropzone.drag_and_drop_or_click_to_replace": "Drag And Drop Or Click To Replace",
  "components.dropzone.drag_and_drop_or_click_to_upload": "Drag And Drop Or Click To Upload",
  "components.dropzone.less_than": "Less Than",
  "components.dropzone.upload_a_file": "Upload a File",
  "components.dropzone.upload_files": "Upload Files",
  "components.gantt.issues": "Issues",
  "components.gantt.remove_marker": "Remove Marker",
  "components.install_app.components_install_app_ios_safari_requires_manual_install_steps": "Ios Safari Requires Manual Install Steps",
  "components.localized_fields.components_localized_fields_ai_prefill": "AI Prefill",
  "components.localized_fields.components_localized_fields_change_primary": "Change Primary",
  "components.localized_fields.components_localized_fields_multi": "Multi",
  "components.localized_fields.components_localized_fields_multi_language_view": "Multi Language View",
  "components.offline_action_unavailable_message.this_action_is_unavailable_while_offline": "This Action Is Unavailable While Offline",
  "components.offline_banner.you_are_offline_some_features_may_be_unavailable_until_your_connection": "You Are Offline Some Features May Be Unavailable Until Your Connection",
  "components.offline_empty_cache_state.this_page_is_unavailable_offline_because_it_has_not_been_loaded": "This Page Is Unavailable Offline Because It Has Not Been Loaded",
  "components.offline_state_panel.cannot_verify_your_session_while_offline": "Cannot Verify Your Session While Offline",
  "components.offline_state_panel.reconnect_to_continue": "Reconnect To Continue",
  "components.resizable.components_resizable_panel_group_resize_panels": "Panel Group Resize Panels",
  "components.seating_layout_planner.components_seating_layout_planner_assigned_seat": "Assigned Seat",
  "components.seating_layout_planner.components_seating_layout_planner_fit": "Fit",
  "components.seating_layout_planner.components_seating_layout_planner_open_seat": "Open Seat",
  "components.seating_layout_planner.components_seating_layout_planner_pending_rsvp": "Pending RSVP",
  "components.seating_layout_planner.components_seating_layout_planner_rotate": "Rotate",
  "components.seating_layout_planner.components_seating_layout_planner_tables": "Tables",
  "components.shell.account_delete_failed_title": "Account Delete Failed",
  "components.shell.chat": "Chat",
  "components.shell.components_shell_99": "99",
  "components.shell.components_shell_account_actions": "Account Actions",
  "components.shell.components_shell_ai_assistant": "AI Assistant",
  "components.shell.components_shell_ai_prompt": "AI Prompt",
  "components.shell.components_shell_all_channels": "All Channels",
  "components.shell.components_shell_all_statuses": "All Statuses",
  "components.shell.components_shell_ask_ai": "Ask AI",
  "components.shell.components_shell_change_password": "Change Password",
  "components.shell.components_shell_channels": "Channels",
  "components.shell.components_shell_could_not_archive_this_notification": "Could Not Archive This Notification",
  "components.shell.components_shell_could_not_restore_this_notification": "Could Not Restore This Notification",
  "components.shell.components_shell_delete_account": "Delete Account",
  "components.shell.components_shell_filter_notifications_by_channel": "Filter Notifications By Channel",
  "components.shell.components_shell_filter_notifications_by_status": "Filter Notifications By Status",
  "components.shell.components_shell_how_can_we_help": "How Can We Help",
  "components.shell.components_shell_in_occasion": "In Occasion",
  "components.shell.components_shell_language_preference": "Language Preference",
  "components.shell.components_shell_linked_contacts": "Linked Contacts",
  "components.shell.components_shell_loading_notifications": "Loading Notifications",
  "components.shell.components_shell_manage_cookie_preferences": "Manage Cookie Preferences",
  "components.shell.components_shell_mark_all_as_read": "Mark All As Read",
  "components.shell.components_shell_mark_all_notifications_as_read": "Mark All Notifications As Read",
  "components.shell.components_shell_new_password": "New Password",
  "components.shell.components_shell_no_linked_contacts_are_connected_to_this_account": "No Linked Contacts Are Connected To This Account",
  "components.shell.components_shell_no_notifications_yet": "No Notifications Yet",
  "components.shell.components_shell_not_configured": "Not Configured",
  "components.shell.components_shell_notification": "Notification",
  "components.shell.components_shell_notifications": "Notifications",
  "components.shell.components_shell_notifications_are_not_configured": "Notifications Are Not Configured",
  "components.shell.components_shell_open_ai_assistant": "Open AI Assistant",
  "components.shell.components_shell_open_notifications": "Open Notifications",
  "components.shell.components_shell_profile": "Profile",
  "components.shell.components_shell_profile_image": "Profile Image",
  "components.shell.components_shell_refresh_notifications": "Refresh Notifications",
  "components.shell.components_shell_remove_image": "Remove Image",
  "components.shell.components_shell_running": "Running",
  "components.shell.components_shell_save_profile": "Save Profile",
  "components.shell.components_shell_saving": "Saving",
  "components.shell.components_shell_security_privacy": "Security Privacy",
  "components.shell.components_shell_sending": "Sending",
  "components.shell.components_shell_show_archived_notifications": "Show Archived Notifications",
  "components.shell.components_shell_unread_only": "Unread Only",
  "components.shell.components_shell_updating": "Updating",
  "components.shell.components_shell_verified": "Verified",
  "components.shell.components_shell_verify_email": "Verify Email",
  "components.shell.email_verification_failed_title": "Email Verification Failed",
  "components.shell.email_verification_sent_title": "Email Verification Sent",
  "components.shell.error": "Error",
  "components.shell.in_app": "In App",
  "components.shell.notifications_could_not_be_loaded": "Notifications Could Not Be Loaded",
  "components.shell.password_update_failed_title": "Password Update Failed",
  "components.shell.profile_image_invalid_title": "Profile Image Invalid",
  "components.shell.profile_save_failed_title": "Profile Save Failed",
  "components.shell.push": "Push",
  "components.shell.select_an_occasion_to_run_ai_assistance": "Select An Occasion To Run AI Assistance",
  "components.shell.sent": "Sent",
  "components.shell.sms": "SMS",
  "components.shell.warning": "Warning",
  "components.shell.what_do_you_want_me_to_do": "What Do You Want Me To Do",
  "components.smart_table_search.components_smart_table_search_add_a_filter": "Add a Filter",
  "components.smart_table_search.components_smart_table_search_and_value": "And Value",
  "components.smart_table_search.components_smart_table_search_choose_a_second_value": "Choose a Second Value",
  "components.smart_table_search.components_smart_table_search_choose_a_value": "Choose a Value",
  "components.smart_table_search.components_smart_table_search_press_apply_to_add_this_filter": "Press Apply To Add This Filter",
  "components.smart_table_search.components_smart_table_search_search_text_stays_active_start_with_a_filter": "Search Text Stays Active Start With a Filter",
  "components.smart_table_search.contains": "Contains",
  "components.smart_table_search.ends_with": "Ends With",
  "components.smart_table_search.is": "Is",
  "components.smart_table_search.is_empty": "Is Empty",
  "components.smart_table_search.is_exactly": "Is Exactly",
  "components.smart_table_search.is_greater_than": "Is Greater Than",
  "components.smart_table_search.is_in": "Is In",
  "components.smart_table_search.is_less_than": "Is Less Than",
  "components.smart_table_search.is_not": "Is Not",
  "components.smart_table_search.is_not_empty": "Is Not Empty",
  "components.smart_table_search.selected": "Selected",
  "components.smart_table_search.starts_with": "Starts With",
  "components.stale_data_badge.saved_data": "Saved Data",
  "components.tags_field.components_tags_field_no_matching_values": "No Matching Values",
  "components.tags_field.components_tags_field_search_values": "Search Values",
  "components.tags_field.components_tags_field_select_values": "Select Values",
  "components.toast.components_toast_dismiss_notification": "Dismiss Notification",
  "components.tov.components_tov_close_dialog": "Close Dialog",
  "config.planner_views.calendar_view": "Calendar View",
  "config.planner_views.data_table": "Data Table",
  "config.planner_views.gallery_view": "Gallery View",
  "config.planner_views.gantt_view": "Gantt View",
  "config.planner_views.grid_view": "Grid View",
  "config.planner_views.kanban_view": "Kanban View",
  "config.planner_views.layout_view": "Layout View",
  "config.planner_views.list_view": "List View",
  "config.planner_views.map_view": "Map View",
  "config.planner_views.table_view": "Table View",
  "connectivity.use_online_action_guard.this_action_requires_an_internet_connection": "This Action Requires An Internet Connection",
  "design.design_system.action_button": "Action Button",
  "design.design_system.admin": "Admin",
  "design.design_system.docs": "Docs",
  "design.design_system.field_shell": "Field Shell",
  "design.design_system.guest": "Guest",
  "design.design_system.marketing": "Marketing",
  "design.design_system.meta_badge": "Meta Badge",
  "design.design_system.planner": "Planner",
  "design.design_system.surface_card": "Surface Card",
  "design.design_system.vendor": "Vendor",
  "general.actions.acknowledge": "Acknowledge",
  "general.actions.apply": "Apply",
  "general.actions.approve": "Approve",
  "general.actions.archive": "Archive",
  "general.actions.back": "Back",
  "general.actions.cancel": "Cancel",
  "general.actions.choose": "Choose",
  "general.actions.clear": "Clear",
  "general.actions.close": "Close",
  "general.actions.continue": "Continue",
  "general.actions.copy": "Copy",
  "general.actions.create": "Create",
  "general.actions.delete": "Delete",
  "general.actions.disable": "Disable",
  "general.actions.dismiss": "Dismiss",
  "general.actions.edit": "Edit",
  "general.actions.enable": "Enable",
  "general.actions.export": "Export",
  "general.actions.import": "Import",
  "general.actions.next": "Next",
  "general.actions.open": "Open",
  "general.actions.previous": "Previous",
  "general.actions.refresh": "Refresh",
  "general.actions.reject": "Reject",
  "general.actions.remove": "Remove",
  "general.actions.reset": "Reset",
  "general.actions.retry": "Retry",
  "general.actions.review": "Review",
  "general.actions.save": "Save",
  "general.actions.save_changes": "Save Changes",
  "general.actions.saving": "Saving",
  "general.actions.select": "Select",
  "general.actions.share": "Share",
  "general.actions.try_again": "Try Again",
  "general.actions.upload": "Upload",
  "general.actions.view": "View",
  "general.booleans.no": "No",
  "general.booleans.yes": "Yes",
  "general.calendar.today": "Today",
  "general.empty.no_caption_provided": "No Caption Provided",
  "general.empty.no_visible_message_body": "No Visible Message Body",
  "general.fields.action.label": "Action",
  "general.fields.actions.label": "Label",
  "general.fields.address.label": "Address",
  "general.fields.audience.label": "Audience",
  "general.fields.avatar.label": "Avatar",
  "general.fields.category.label": "Category",
  "general.fields.channel.label": "Channel",
  "general.fields.color.label": "Color",
  "general.fields.country.label": "Country",
  "general.fields.date.label": "Date",
  "general.fields.default_locale.label": "Default Language",
  "general.fields.description.label": "Description",
  "general.fields.display_name.label": "Display Name",
  "general.fields.duration.label": "Duration",
  "general.fields.email.label": "Email",
  "general.fields.event.label": "Event",
  "general.fields.first_name.label": "First Name",
  "general.fields.language.label": "Language",
  "general.fields.last_name.label": "Last Name",
  "general.fields.lifecycle.label": "Lifecycle",
  "general.fields.locale.label": "Language",
  "general.fields.location.label": "Location",
  "general.fields.message.label": "Message",
  "general.fields.name.label": "Name",
  "general.fields.note.label": "Label",
  "general.fields.notes.label": "Notes",
  "general.fields.occasion.label": "Occasion",
  "general.fields.phone.label": "Phone",
  "general.fields.priority.label": "Priority",
  "general.fields.quantity.label": "Quantity",
  "general.fields.reason.label": "Reason",
  "general.fields.response.label": "Response",
  "general.fields.scope.label": "Scope",
  "general.fields.search.label": "Search",
  "general.fields.search.placeholder": "Search",
  "general.fields.section.label": "Section",
  "general.fields.size.label": "Size",
  "general.fields.slug.label": "Slug",
  "general.fields.status.label": "Status",
  "general.fields.target.label": "Target",
  "general.fields.timezone.label": "Timezone",
  "general.fields.type.label": "Type",
  "general.fields.value.label": "Value",
  "general.fields.visibility.label": "Visibility",
  "general.fields.welcome_message.label": "Label",
  "general.filters.all": "All",
  "general.languages.en": "English",
  "general.languages.he": "Hebrew",
  "general.modules.activity.name": "Activity",
  "general.modules.assignments.name": "Assignments",
  "general.modules.communications.name": "Communications",
  "general.modules.contacts.name": "Contacts",
  "general.modules.dashboard.name": "Dashboard",
  "general.modules.deliverables.name": "Deliverables",
  "general.modules.events.name": "Events",
  "general.modules.forms.name": "Forms",
  "general.modules.gallery.name": "Gallery",
  "general.modules.locations.name": "Locations",
  "general.modules.messages.name": "Messages",
  "general.modules.monitoring.name": "Monitoring",
  "general.modules.overview.name": "Overview",
  "general.modules.publishing.name": "Publishing",
  "general.modules.registry.name": "Registry",
  "general.modules.rsvp.name": "RSVP",
  "general.modules.schedule.name": "Schedule",
  "general.modules.seating.name": "Seating",
  "general.modules.task_boards.name": "Task Boards",
  "general.modules.tasks.name": "Tasks",
  "general.modules.templates.name": "Templates",
  "general.modules.updates.name": "Updates",
  "general.navigation.return_to_overview": "Return To Overview",
  "general.pagination.first_page": "First Page",
  "general.pagination.last_page": "Last Page",
  "general.pagination.next_page": "Next Page",
  "general.pagination.page": "Page",
  "general.pagination.previous_page": "Previous Page",
  "general.pagination.rows_per_page": "Rows Per Page",
  "general.pagination.zero_items_summary": "No Items",
  "general.selection.select_an_option": "Select An Option",
  "general.sort.ascending": "Ascending",
  "general.sort.descending": "Descending",
  "general.states.access_unavailable_title": "Access Unavailable",
  "general.states.address_pending": "Address Pending",
  "general.states.empty_title": "No Items",
  "general.states.error_title": "Error Title",
  "general.states.feature_unavailable_title": "Feature Unavailable",
  "general.states.loading_title": "Loading",
  "general.states.no_results_title": "No Results",
  "general.states.not_found_title": "Not Found",
  "general.states.occasion_not_available_title": "Occasion Not Available",
  "general.states.pending": "Pending",
  "general.states.retry_occasion_loading": "Retry Occasion Loading",
  "general.states.saving": "Saving",
  "general.states.unknown_error_title": "Unknown Error",
  "general.status.active": "Active",
  "general.status.approved": "Approved",
  "general.status.archived": "Archived",
  "general.status.attention": "Attention",
  "general.status.available": "Available",
  "general.status.blocked": "Blocked",
  "general.status.cancelled": "Cancelled",
  "general.status.closed": "Closed",
  "general.status.complete": "Complete",
  "general.status.completed": "Completed",
  "general.status.configured": "Configured",
  "general.status.declined": "Declined",
  "general.status.delivered": "Delivered",
  "general.status.disabled": "Disabled",
  "general.status.draft": "Draft",
  "general.status.enabled": "Enabled",
  "general.status.failed": "Failed",
  "general.status.fulfilled": "Fulfilled",
  "general.status.idle": "Idle",
  "general.status.in_progress": "In Progress",
  "general.status.loading": "Loading",
  "general.status.locked": "Locked",
  "general.status.off": "Off",
  "general.status.on": "On",
  "general.status.optional": "Optional",
  "general.status.overdue": "Overdue",
  "general.status.pending": "Pending",
  "general.status.published": "Published",
  "general.status.ready": "Ready",
  "general.status.rejected": "Rejected",
  "general.status.required": "Required",
  "general.status.revoked": "Revoked",
  "general.status.saving": "Saving",
  "general.status.scheduled": "Scheduled",
  "general.status.submitting": "Submitting",
  "general.status.unavailable": "Unavailable",
  "general.status.unknown": "Unknown",
  "general.status.upcoming": "Upcoming",
  "general.time.after": "After",
  "general.time.before": "Before",
  "general.units.kb": "Kb",
  "general.values.no": "No",
  "general.values.yes": "Yes",
  "landing.environment.local": "LOCAL",
  "landing.environment.non_production": "NON-PRODUCTION",
  "landing.environment.staging": "STAGING",
  "landing.environment.tag_label": "Environment tag",
  "pages.billing_page.billing_owner": "Billing Owner",
  "pages.billing_page.no_promotions": "No Promotions",
  "pages.billing_page.promotions": "Promotions",
  "pages.form_details_page.revision": "Revision",
  "pages.forms_page.pages_forms_page_reset_local_draft": "Reset Local Draft",
  "pages.forms_page.pages_forms_page_select_one_or_more_options": "Select One Or More Options",
  "pages.forms_page.pages_forms_page_submit_form": "Submit Form",
  "pages.forms_page.pages_forms_page_submitted": "Submitted",
  "pages.forms_page.pages_forms_page_visible_form": "Visible Form",
  "pages.forms_page.pages_forms_page_visible_forms": "Visible Forms",
  "pages.gallery_page.gallery_comments": "Gallery Comments",
  "pages.gallery_page.gallery_no_comments": "Gallery No Comments",
  "pages.gallery_page.pages_gallery_page_caption": "Caption",
  "pages.gallery_page.pages_gallery_page_occasion_wide": "Occasion Wide",
  "pages.gallery_page.pages_gallery_page_uploading": "Uploading",
  "pages.integrations_page.pages_integrations_page_attempts": "Attempts",
  "pages.integrations_page.pages_integrations_page_auth": "Auth",
  "pages.integrations_page.pages_integrations_page_config_v": "Config v",
  "pages.integrations_page.pages_integrations_page_connections": "Connections",
  "pages.integrations_page.pages_integrations_page_jobs": "Jobs",
  "pages.integrations_page.pages_integrations_page_last_sync": "Last Sync",
  "pages.integrations_page.pages_integrations_page_mappings": "Mappings",
  "pages.integrations_page.pages_integrations_page_never": "Never",
  "pages.integrations_page.pages_integrations_page_recent_activity": "Recent Activity",
  "pages.integrations_page.pages_integrations_page_to": "To",
  "pages.placeholder_feature_page.pages_placeholder_feature_page_next_implementation_focus": "Next Implementation Focus",
  "pages.placeholder_feature_page.pages_placeholder_feature_page_review_occasions": "Review Occasions",
  "pages.rsvp.rsvp_page.pages_rsvp_rsvp_page_share_a_note_or_any_special_requests": "Share a note or any special requests...",
  "pages.schedule_page.pages_schedule_page_timeline_item": "Timeline Item",
  "pages.seating.seating_areas_tab.pages_seating_seating_areas_tab_sort": "Sort",
  "publishing.settings.preset_label": "Preset",
  "ui.opening_experience.classic_reveal_description": "Classic reveal",
  "ui.opening_experience.elegant_lift_description": "Elegant lift",
  "ui.opening_experience.envelope_description": "Envelope",
  "ui.opening_experience.envelope_open_description": "Envelope open",
  "ui.opening_experience.fade_description": "Fade",
  "ui.opening_experience.folded_card_description": "Folded Card",
  "ui.opening_experience.interactive_envelope_description": "Interactive Envelope",
  "ui.opening_experience.none_description": "None",
  "ui.opening_experience.player_label": "Invitation opening experience",
  "ui.opening_experience.preview_label": "Preview opening experience",
  "ui.opening_experience.simple_fade_description": "Simple fade",
  "ui.opening_experience.skip_animation": "Skip Animation",
  "ui.opening_experience.soft_unfold_description": "Soft unfold"
}
